
<div id="container-infiniteScrollListComponent">
  <ul *ngIf="!alphaDisplay" [ngClass]="{ 'col5': isNonFictionBooks }" [class]="listStyle" #content>
    <li *ngFor="let item of theItems; trackBy: trackItem">
      <article>
        <a (click)="pushImageClickToGA(item.title, item)" [routerLink]="[path + item.id ]" [queryParams]="linkParams"
           [ngStyle]="{ 'background-image': listStyle === defaultStyle ? 'url(' + item.imageUrl + ')' : undefined }">
          <h5 [innerHTML]="item.title"></h5>
        </a>
      </article>
    </li>
  </ul>

  <ol *ngIf="alphaDisplay" [ngClass]="{ 'col5': isNonFictionBooks }" class="list-alpha" #content>
    <li *ngFor="let item of theItems">
      <h2>{{ item.letter }}</h2>
        <ul [class]="listStyle">
          <li *ngFor="let topic of item.collection; trackBy: trackItem">
            <article>
              <a (click)="pushImageClickToGA(topic.title, topic)" [routerLink]="[path + topic.id ]"
                 [ngStyle]="{ 'background-image': listStyle === defaultStyle ? 'url(' + topic.imageUrl + ')' : undefined }">
                <h5 [innerHTML]="topic.title"></h5>
              </a>
            </article>
          </li>
        </ul>
    </li>
  </ol>

  <div *ngIf="page === 0 && eof">Sorry! We’re experiencing some kind of problem. Please try back later or check out another category.</div>

  <div *ngIf="isLoading && !eof">
    <div class="loader" aria-label="loading..." role="alert" aria-busy="true"></div>
  </div>

  <div class="container-loadmore" *ngIf="!enableInfiniteLoading && !eof">
    <button type="button" class="btn btn-default" (click)="requestLoadMoreItems()">Load more Research Topics</button>
  </div>
</div>

